import { nanoid } from 'nanoid';
import {
  SET_AUTH_TOKEN,
  SET_CURRENT_MANAGER,
  SET_TIME,
  RESET_SERVER_ERROR,
  SET_LEADER_INSTANCE,
  SET_CRM_STATUS,
  SET_CRM_STATUS_SUCCESS,
  RESET_ERRORS,
  UNSET_LEADER_INSTANCE,
  SENTRY_ENABLED,
  SET_ASSETS_VERSION,
  SET_HAS_ASSET_UPDATES,
  SET_MANAGER_STATUSES,
  SET_WS_CURRENT_MANAGER_TICKETS_COUNT,
  CRM_SYNC_GENERAL_STATE,
  SET_TAB_ACTIVE,
  SET_NOTIFICATIONS_COUNT,
  RESET_NOTIFICATIONS_COUNT,
  SET_IS_NOTIFICATIONS_SOUND_ENABLED,
  SWITCH_THEME,
  SET_VOLUME,
} from '../actions/general';
import {
  SAVE_ERROR,
  SAVE_CRITICAL_ERRORS,
  RESET_CRITICAL_ERRORS,
} from '../../consts/errors';
import { WS_CONNECTED, WS_DISCONNECTED } from '../actions/updates';

const initTime = Math.round(Date.now() / 1000);

const initialState = {
  currentManager: null,
  errors: {
    critical: [],
    general: [],
  },
  isWSConnected: false,
  serverTime: initTime,
  serverTimeUpdatedAt: initTime,
  serverError: null,
  token: null,
  isSentryEnabled: false,
  isMasterInstance: false,
  assetVersions: {},
  hasAssetUpdates: false,
  managerStatuses: null,
  sessionId: nanoid(),
  notificationsCount: 0,
  isTabActive: true,
  isNotificationsSoundEnabled: false,
  theme: 'light',
  volume: Number(localStorage.getItem('crm-volume')) || 100,
};

export default (state = initialState, { payload, error, type }) => {
  switch (type) {
    case SAVE_ERROR: {
      return {
        ...state,
        errors: {
          ...state.errors,
          general: [error, ...state.errors.general],
        },
      };
    }

    case RESET_ERRORS: {
      return {
        ...state,
        errors: {
          ...state.errors,
          general: [],
        },
      };
    }

    case SAVE_CRITICAL_ERRORS: {
      return {
        ...state,
        errors: {
          ...state.errors,
          critical: [error, ...state.errors.critical],
        },
      };
    }

    case RESET_CRITICAL_ERRORS: {
      return {
        ...state,
        errors: {
          ...state.errors,
          critical: [],
        },
      };
    }

    case SET_LEADER_INSTANCE: {
      return {
        ...state,
        isMasterInstance: true,
      };
    }

    case UNSET_LEADER_INSTANCE:
      return {
        ...state,
        isMasterInstance: false,
      };

    case RESET_SERVER_ERROR: {
      return { ...state, serverError: null };
    }

    case SET_AUTH_TOKEN: {
      const { token } = payload;
      return { ...state, token };
    }

    case SET_CURRENT_MANAGER: {
      const { currentManager } = payload;

      return {
        ...state,
        currentManager,
      };
    }

    case SET_CRM_STATUS: {
      const { currentManager } = state;
      const { isManual, operatorState } = payload;

      return {
        ...state,
        currentManager: {
          ...currentManager,
          ...(isManual && {
            manualState: Number(operatorState),
          }),
          operatorState: Number(operatorState),
        },
      };
    }

    case SET_CRM_STATUS_SUCCESS: {
      const { currentManager } = state;
      const { isManual, operatorState } = payload;

      return {
        ...state,
        currentManager: {
          ...currentManager,
          ...(isManual && {
            manualState: Number(operatorState),
          }),
          operatorState: Number(operatorState),
          remoteState: Number(operatorState),
        },
      };
    }

    case SET_TIME: {
      const { serverTime } = payload;
      const updatedTime = Math.round(Date.now() / 1000);

      Date.getServerTime = function () {
        const now = Math.round(Date.now() / 1000);
        const diff = now - updatedTime;
        return serverTime + diff;
      };

      return { ...state, serverTime, serverTimeUpdatedAt: updatedTime };
    }

    case WS_CONNECTED: {
      return { ...state, isWSConnected: true };
    }

    case WS_DISCONNECTED: {
      return { ...state, isWSConnected: false };
    }

    case SENTRY_ENABLED: {
      return { ...state, isSentryEnabled: true };
    }

    case SET_ASSETS_VERSION: {
      const { assetVersions } = payload;
      return { ...state, assetVersions };
    }

    case SET_HAS_ASSET_UPDATES: {
      const { hasAssetUpdates } = payload;
      return { ...state, hasAssetUpdates };
    }

    case SET_MANAGER_STATUSES: {
      const { managerStatuses } = payload;

      return { ...state, managerStatuses };
    }

    case SET_WS_CURRENT_MANAGER_TICKETS_COUNT: {
      const { currentManager } = state;
      const { activeTicketsCount, reservedTicketsCount } = payload;

      return {
        ...state,
        currentManager: {
          ...currentManager,
          activeTicketsCount,
          reservedTicketsCount,
        },
      };
    }

    case CRM_SYNC_GENERAL_STATE: {
      const { general } = payload;
      return {
        ...state,
        ...general,
        isMasterInstance: state.isMasterInstance,
        sessionId: state.sessionId,
      };
    }

    case SET_TAB_ACTIVE: {
      const { isTabActive } = payload;
      return {
        ...state,
        isTabActive,
      };
    }

    case SET_NOTIFICATIONS_COUNT: {
      const { notificationsCount } = payload;
      return {
        ...state,
        notificationsCount,
      };
    }

    case RESET_NOTIFICATIONS_COUNT: {
      return {
        ...state,
        notificationsCount: 0,
      };
    }

    case SET_IS_NOTIFICATIONS_SOUND_ENABLED: {
      const { isNotificationsSoundEnabled } = payload;
      return {
        ...state,
        isNotificationsSoundEnabled,
      };
    }

    case SWITCH_THEME: {
      return { ...state, theme: payload };
    }

    case SET_VOLUME: {
      return { ...state, volume: payload };
    }

    default:
      return state;
  }
};
